import css from 'styled-jsx/css';

export default css`.carouselImageList {
  width: 100%; }
  .carouselImageList .mainImageOuter {
    width: 100%; }
  .carouselImageList .carouselHover :global(.slick-slider):hover :global(.slick-prev),
  .carouselImageList .carouselHover :global(.slick-slider):hover :global(.slick-next) {
    display: flex !important; }
  .carouselImageList .coverOuter {
    position: relative;
    display: block !important; }
    .carouselImageList .coverOuter .carousel__captions {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 100px;
      padding: 80px 16px 16px;
      background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8));
      font-size: 12px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-end; }
      .carouselImageList .coverOuter .carousel__captions .carousel__source {
        cursor: pointer;
        float: left;
        flex: 1;
        color: #fff; }
      .carouselImageList .coverOuter .carousel__captions .carousel__pagination {
        float: right; }
  .carouselImageList .cover {
    position: relative;
    display: block;
    width: 100%;
    object-fit: contain; }
    .carouselImageList .cover img {
      display: block;
      width: 100%;
      max-width: 100%;
      max-height: 600px;
      overflow: hidden;
      object-fit: contain;
      margin: auto; }
  .carouselImageList :global(.slick-slider) {
    width: 100%; }
    .carouselImageList :global(.slick-slider) :global(.slick-list) {
      width: 100%; }
    .carouselImageList :global(.slick-slider) :global(.slick-track) {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center; }
    .carouselImageList :global(.slick-slider) :global(.slick-prev),
    .carouselImageList :global(.slick-slider) :global(.slick-next) {
      display: none !important;
      width: 32px;
      height: 100%;
      border: 0 solid #000;
      outline: none;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 0;
      z-index: 1; }
      .carouselImageList :global(.slick-slider) :global(.slick-prev)::before,
      .carouselImageList :global(.slick-slider) :global(.slick-next)::before {
        content: ''; }
      .carouselImageList :global(.slick-slider) :global(.slick-prev) button,
      .carouselImageList :global(.slick-slider) :global(.slick-next) button {
        border: 0;
        cursor: pointer;
        background-color: transparent;
        padding: 8px; }
    .carouselImageList :global(.slick-slider) :global(.slick-prev) {
      left: 0;
      background: linear-gradient(to right, rgba(136, 136, 136, 0.5), rgba(0, 0, 0, 0)); }
    .carouselImageList :global(.slick-slider) :global(.slick-next) {
      right: 0;
      background: linear-gradient(to left, rgba(136, 136, 136, 0.5), rgba(0, 0, 0, 0)); }
    .carouselImageList :global(.slick-slider) :global(.slick-prev button) {
      margin-left: 16px; }

:global(.icon-arrow-right1),
:global(.icon-arrow-left1) {
  width: 32px;
  height: 32px;
  color: rgba(255, 255, 255, 0.9); }

:global(button.ril__zoomOutButton),
:global(button.ril__zoomInButton) {
  display: none; }
`